import Rete from 'rete'

import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import {
  socketToComponent
} from '../../data'
import { 
  createComponentListNode,
  createNodeByComponentName,
  createSequenceAndChildrenNodes,
} from '../../functions/utils'

const doNotAllowNodeCreationFromTheseSocketNames = [
  CONST_SOCKET.COMPONENT_LIST_INPUT
]

export const displayComponentListAndCreateNodeOnClick = (io) => {
  if (window.XIT_FLOW_BUILDER_FLAG_COMPONENT_LIST_ACTION_CONNECTION_TYPE instanceof Rete.Output) {
    if (CONST_COMPONENT.BUTTON === io.node.name || CONST_COMPONENT.QUICK_REPLY === io.node.name) {
      return;
    }

    setTimeout(async function() {
      const { x, y } = App.editor.view.area.mouse
      const socketArray = io.socket.compatible.map(x => x.name)
      
      const uniqueSocketNamesArray = [...new Set(socketArray)]
      const filteredSocketNamesArray = uniqueSocketNamesArray.filter((item, index) => { // eslint-disable-line
        return doNotAllowNodeCreationFromTheseSocketNames.indexOf(item) === -1
      })

      const targetElement = getTargetElementHovered()

      if ($(targetElement).hasClass('ui-droppable')) {
        if (filteredSocketNamesArray.length === 1) {
          const targetComponent = socketToComponent[filteredSocketNamesArray[0]]

          if (targetComponent) {
            if (CONST_COMPONENT.SEQUENCE === targetComponent.name) {
              if (io.connections.length === 1) {
                return;
              }

              const sequenceNode = await createSequenceAndChildrenNodes()
              App.editor.connect(io.node.outputs.get(io.key), sequenceNode.inputs.get(filteredSocketNamesArray[0]))
            } 
            else if (CONST_COMPONENT.POSTBACK === targetComponent.name) {
              const referenceNode = App.editor.nodes.find(item => item.name === CONST_COMPONENT.POSTBACK)
              if (referenceNode) {
                const referenceNodeInput = referenceNode.inputs.get(filteredSocketNamesArray[0])
                App.editor.connect(io, referenceNodeInput)
              }
            }
            else {
              await createSingleNode(io, targetComponent.name, filteredSocketNamesArray)
            }

            // Resets the pseudo connection
            App.editor.trigger('resetconnection') 

            return;
          }
        }

        if (io.connections.length === 0) {
          removeNodeIfItAlreadyExists()

          const componentListNode = await createComponentListNode()
          componentListNode.position = [x, y]
          componentListNode.output = io
          componentListNode.compatibleInputs = filteredSocketNamesArray
    
          App.editor.addNode(componentListNode)
          App.editor.connect(
            io.node.outputs.get(io.key),
            componentListNode.inputs.get(CONST_SOCKET.COMPONENT_LIST_INPUT)
          )
        }
      }
    }, 250)
  }
}

const getTargetElementHovered = () => {
  let elements = document.querySelector(":hover")
  let targetElement
  while (elements) {
    targetElement = elements
    elements = targetElement.querySelector(":hover")
  }

  return targetElement
}

const createSingleNode = async (output, componentName, filteredSocketNamesArray) => {
  if ((output.connections.length === 1) && (CONST_COMPONENT.POSTBACK_NEW === componentName)) {
    return;
  }

  const targetNode = await createNodeByComponentName(componentName)
  const { x, y } = App.editor.view.area.mouse
  targetNode.position = [x, y]

  App.editor.addNode(targetNode)

  App.editor.connect(
    output.node.outputs.get(output.key),
    targetNode.inputs.get(filteredSocketNamesArray[0])
  )

  return targetNode
}

const removeNodeIfItAlreadyExists = () => {
  for (const node of App.editor.nodes) {
    if (node.name === CONST_COMPONENT.COMPONENT_LIST) {
      App.editor.removeNode(node)
      break
    }
  }
}